__turbopack_context__.v({
  "add-field-heading": "AddFieldSection-module-scss-module__Zg3twW__add-field-heading",
  "add-field-section": "AddFieldSection-module-scss-module__Zg3twW__add-field-section",
  "field-list": "AddFieldSection-module-scss-module__Zg3twW__field-list",
});
